module.exports = __webpack_public_path__ + "img/12.0ad30297.jpg";